import type { Context } from '@datadog/browser-core';
import { datadogRum } from '@datadog/browser-rum';
import { AbstractTracker, TrackEventParameters, UserTraits } from './AbstractTracker';

export class DatadogRumModule extends AbstractTracker {
  init(): void {
    const applicationId = process.env.REACT_APP_DATADOG_RUM_APPLICATION_ID;
    const clientToken = process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN;

    if (!applicationId || !clientToken) {
      return;
    }

    datadogRum.init({
      applicationId,
      clientToken,
      site: process.env.REACT_APP_DATADOG_RUM_SITE || 'datadoghq.com',
      service: process.env.REACT_APP_DATADOG_RUM_SERVICE || 'modal-b2b',
      env: (process.env.REACT_APP_DATADOG_RUM_ENV || 'staging').toLowerCase(),
      version: process.env.REACT_APP_VERSION || 'latest',
      sessionSampleRate: 10,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      trackViewsManually: false,
      defaultPrivacyLevel: 'mask-user-input',
      useSecureSessionCookie: true,
      usePartitionedCrossSiteSessionCookie: true,
      trackSessionAcrossSubdomains: true,
      allowFallbackToLocalStorage: true,
      allowedTracingUrls: [
        /https:\/\/.*\.nexodata\.com\.br/,
        /https:\/\/.*\.mevosaude\.com\.br/,
      ],
      beforeSend: (event) => {
        if (event.type === 'error') {
          const stack = event.error?.stack ?? '';
          if (stack.includes('chrome-extension://') || stack.includes('moz-extension://')) {
            return false;
          }
        }
        return true;
      },
    });
  }

  trackEvent({ event, parameters }: TrackEventParameters): void {
    datadogRum.addAction(event, parameters);
  }

  peopleSet(_event: string, _parameter: any): void {
    // Datadog RUM não tem equivalente direto, user context é setado via identify
  }

  peopleSetOnce(_event: string, _parameter: any): void {
    // Datadog RUM não tem equivalente direto
  }

  identify(identifier: string, traits?: UserTraits): void {
    datadogRum.setUser({
      id: identifier,
      ...(traits?.name ? { name: traits.name } : {}),
      ...(traits?.email ? { email: traits.email } : {}),
    });
  }

  register(parameters: object): void {
    datadogRum.setGlobalContext(parameters as Context);
  }
}
